import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Sales() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneMessage, setPhoneMessage] = useState("");
  const [nameMessage, setNameMessage] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  function convertArabicToEnglishNumbers(input) {
    return input.replace(/[\u0660-\u0669]/g, (d) => d.charCodeAt(0) - 0x0660);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setNameMessage("");
    setPhoneMessage("");

    if (name.trim() === "") {
      setNameMessage("❌ من فضلك أدخل اسم صحيح");
      return;
    }

    const phoneRegex =
      /^(?:(?:010|011|015)[0-9]{8}|(?:0127|0128|0120|0121)[0-9]{7})$/;

    const normalizedPhone = convertArabicToEnglishNumbers(phone); // ✅ تحويل الرقم

    if (!phoneRegex.test(normalizedPhone)) {
      setPhoneMessage(
        "❌ من فضلك أدخل رقم هاتف صحيح يبدأ بـ 010 - 011 - 015 - 0127 - 0128 - 0120 - 0121 ويتكون من 11 رقم"
      );
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbxHJ-9_2PkRWPuYQ55T-cU-4Sz0jLp-yU9yBNKtFaqh7sValMnYXl0ny25kTypk3v_K/exec",
        {
          method: "POST",
          // headers: {
          //   "Content-Type": "application/json", // ✅ مهم جدا
          // },
          body: JSON.stringify({ name, phone: 2 + normalizedPhone }),
        }
      );
      const result = await res.json();
      // ✅ اقرأ الرد كـ JSON
      setLoading(false);

      if (result.success) {
        setMessage("✅ " + result.message);
        setName("");
        setPhone("");
        navigate("/final");
      } else {
        setMessage("❌ حدث خطأ أثناء إرسال البيانات.");
      }
    } catch (error) {
      setMessage("❌ حدث خطأ أثناء إرسال البيانات، حاول مرة أخرى.");
      console.error(error);
    }
  };

  const scrollToForm = () => {
    document
      .getElementById("form-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className=" max-w-4xl mx-auto bg-blue-950 text-white">
      <section className=" mx-auto text-center">
        <img alt="hero-image" src="/hero-img.webp" />
        <button
          onClick={scrollToForm}
          className="bg-red-600 text-white px-6 py-3 rounded mt-12 hover:bg-red-700"
        >
          اطلب الآن
        </button>
      </section>

      <section className="p-8 text-right ">
        <ul className="mt-8 list-disc list-inside space-y-12">
          <li className="text-xl">
            يقضي تماما علي مشكلة خشونة الركبـة والام المفاصل المزعجة
          </li>
          <li className="text-xl">
            يقضـي تمامـا علـي الام الظهـر ومشاكل العمـود الفقرى والام الرقبة
            المؤلمة
          </li>
          <li className="text-xl">
            افضــل حـل بديل عـن العمليات الجراحيـة المؤلمـة وغيـر مضمونـة وباهظة
            الثمن
          </li>
          <li className="text-xl">
            يعطيك مفاصل قوية واكثر مرونة بفضل تركيبة سم النحل المتطورة
          </li>
        </ul>
      </section>

      <section className="text-center">
        <p className="mt-4 text-2xl p-8 text-right">
          كيف يعمل منتج موفكس <b>چيل</b> <br /> علي ازالة الالام وانعاش الغضاريف
          والمفاصل وعودتها قوية ومرنة
        </p>
        <img alt="صورة الطبيب" src="/top-doctor.webp" />
        <button
          onClick={scrollToForm}
          className="bg-red-600 text-white px-6 py-3 rounded mt-12 hover:bg-red-700"
        >
          اطلب الآن
        </button>
        <p className="mt-12 text-2xl px-8 text-right">
          مكونـــــات موفكس <b>چيل</b> الطبيعيـــة الــى خلايــــا
        </p>
        <ul className="p-8 list-disc list-inside space-y-8 text-xl text-right">
          <li>إعادة إفراز السائل الزلالي في المفاصل</li>
          <li>إزالة التهابات المفاصل</li>
          <li>إزالة آلام العمود الفقري والرقبة</li>
          <li>تحسين الحركة واستعادة مرونة المفصل وقوته</li>
          <li>تحسين القدرة على الحركة بدون أي مشكلة أو عناء</li>
        </ul>
      </section>

      <section className="text-center p-8">
        <button
          onClick={scrollToForm}
          className="bg-red-600 text-white px-6 py-3 rounded mb-12 hover:bg-red-700"
        >
          اطلب الآن
        </button>
        <h2 className="text-2xl mb-8 font-bold text-right">
          لماذا ينصح الاطباء باستحدام چيل موفكس
        </h2>
        <p className="text-right">
          انه احدث ما توصل اليه الطب بتركيبة سم النحل المتطورة
        </p>
        <ul className="list-disc list-inside space-y-8 mt-8 text-xl text-right">
          <li>لأنه كورس علاجي نهائي وليس حل مؤقت</li>
          <li>لأنه يعطيك نتيجة وراحة فورية منذ اول استخدام</li>
          <li>لأنه يقضي تماما علي الام الركبة والظهر والرقبة</li>
        </ul>
        <h2 className="text-2xl mt-12 mb-8 font-bold text-right">
          المنتج يصلك فى سرية تامة منعا لاى احراج
        </h2>
      </section>

      {/* <div className="mb-0 bg-gradient-to-r from-blue-300 to-blue-900 text-white text-center py-3 px-4 rounded-md shadow-md animate-bounce">
        <p className="text-lg font-bold ">
          🎉 السعر
          <span className="text-white"> 370 ج فقط بدل من </span>
          <span className="line-through text-white/70">530ج </span>- والشحن{" "}
          <span className="underline">مجاني</span> 🚚
        </p>
      </div> */}

      {/* <div className=" flex justify-around items-center bg-gradient-to-r from-blue-950 to-blue-800">
        <img
          className="w-80 h-96 pb-8 object-contain"
          alt="علبة جل موفكس واقفة بزاوية أمامية"
          src="/product.webp"
        />
        <p className="text-center text-3xl mb-8 ">
          <span className=" block pb-3">
            السعر{" "}
            <b className=" text-4xl underline underline-offset-8 text-green-400">
              {" "}
              370 ج
            </b>{" "}
            فقط
          </span>
          بدل من <span className=" line-through text-red-500">530ج</span> <br />
          والشحن <span className=" font-bold">مجاني</span> 🚚
        </p>
      </div> */}

      <img src="/price.webp" alt="علبة جل موفكس واقفة بزاوية أمامية" />

      {/* ✅ الفورم في آخر الصفحة */}
      <section
        id="form-section"
        className="p-8 text-right bg-blue-800 rounded-lg"
      >
        <h2 className="text-2xl font-bold mb-4 text-blue-100">
          سجل بياناتك الآن
        </h2>
        <p className="mb-6">
          سوف نقوم بالتواصل معكم بكل التفاصيل قبل شحن المنتج
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col space-y-4 max-w-md mx-auto border p-6 rounded backdrop-blur-3xl"
        >
          <label className="font-bold">الأسم</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border p-2 rounded text-black"
          />
          {nameMessage && (
            <p className="text-red-500 font-semibold">{nameMessage}</p>
          )}

          <label className="font-bold">رقم الهاتف</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="border p-2 rounded text-black"
            maxLength={11}
          />
          {phoneMessage && (
            <p className="text-red-500 font-semibold">{phoneMessage}</p>
          )}

          <button
            type="submit"
            disabled={loading} // يمنع الضغط أثناء التحميل
            className="bg-green-600 text-white py-2 rounded hover:bg-green-700 shadow-lg transition flex justify-center items-center"
          >
            {loading ? (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
            ) : (
              "إرسال البيانات"
            )}
          </button>
        </form>

        {message && (
          <p className="mt-8 text-orange-400 font-bold text-lg">{message}</p>
        )}
      </section>
    </div>
  );
}

export default Sales;
